import React, { useRef, useEffect, useCallback, useState} from 'react';
import SampleStreamOption from "components/sidebar/SampleStreamOption.js";
import {getBulkSampleInfo} from 'components/sidebar/getSamples.js';
import {
    setQuickAddSearchText,
} from 'actions/index.js';
import {getSoundResultsServer} from 'components/selector2/getSoundResults.js';
import {connect} from 'react-redux';

let counter=0;
const SourceSamples = ({
    setSearchText,
    track,
    sample,
    sequencerEngine,
    selectedId
}) => { 
    const scrollRef = useRef(undefined);
    let loadingSample = useRef(loadingSample);
    let [samples, setSamples] = useState([]);
    useEffect(() => {
        let sourceToSearch = undefined;

        let searchTerm = "";
        if ( sample.discogsId || (sample.videoId && sample.videoId !== "")) {
            sourceToSearch  = sample.discogsId ? {releaseId: sample.discogsId} :
            {videoId: sample.videoId};
        } else {
            searchTerm = sample.tags[0];
        }

        let _counter = ++counter;
        getSoundResultsServer(
            50, searchTerm, sample.guildId, 'tag', 0, false, sourceToSearch)
            .then(
                async results => {
                    if (_counter !== counter) { return; }
                    if (results.length === 0) {
                        getSoundResultsServer(
                            50, searchTerm, sample.guildId, 'tag', 0, false, sourceToSearch)
                            .then(async (results) => {
                                if (results.length === 0) {
                                    return;
                                }
                                let ids = results.flatMap(x => x.results.map(x => x.ipfsHash));
                                if (ids.length > 50) {
                                    ids = ids.slice(0, 50);
                                }
                                let samples = await getBulkSampleInfo(ids, JSON.stringify(sourceToSearch));
                                setSamples(samples);
                            });
                        return;
                    }
                    let ids = results.flatMap(x => x.results.map(x => x.ipfsHash));
                    if (ids.length > 50) {
                        ids = ids.slice(0, 50);
                    }
                    let samples = await getBulkSampleInfo(ids, JSON.stringify(sourceToSearch));
                    setSamples(samples);
                });
    }, [sample, setSamples]);

    const onClickTag = useCallback(async (tag, metaKey) => {
        loadingSample.current = true;
        setSearchText("");
        let tags=track.samplesStream.tags;
        let _tags = [tag];
        if (metaKey) {
            _tags = [...tags, ..._tags];
        }
        await track.sequencerEngine.searchForSounds(
            _tags, true, track, false);
        loadingSample.current = false;
    }, [track]);

    let _samples = [...samples];
    _samples.sort((a,b) => a.tags[0] && b.tags[0] && a.tags.join(',').localeCompare(b.tags.join(',')));
    return (
        <div
          onMouseDown={(e) => e.stopPropagation()}
          ref={scrollRef} className="source-samples">
        {_samples.map(
            sample => 
                <SampleStreamOption
                  topOffset={150}
                  scrollRef={scrollRef}
                  key={sample.getId()}
                  samples={samples}
                  onClickTag={onClickTag}
                  track={sequencerEngine.getSelectedTrack()}
                  selected={selectedId === sample.getId()}
                  id={sample.getId()} sample={sample} loadingSample={loadingSample} />)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let track = props.sequencerEngine.getSelectedTrack();
  return {
      track,
      selectedId: track && track.sample && track.sample.getId(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchText: x => dispatch(setQuickAddSearchText(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceSamples);
